import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { HealthReportFile } from '@/modules/reports/health-reports/domain/health-report-file';
import { HealthReport } from '@/modules/reports/health-reports/domain/health-report';
import axios from 'axios';

class HealthReports extends HttpRepository {
    private static readonly RESOURCE = 'health-reports';
    async getAll(customerId: number): Promise<HealthReportFile[]> {
        return (
            await this.get(
                this.createUri([`health-reports?customerId=${customerId}`]),
                this.createAuthorizationHeader(),
            )
        ).data;
    }

    getReport(report: HealthReport) {
        return this.get(
            this.createUri([
                `health-reports/${report.name}?customerId=${report.customer}&date=${report.date}`,
            ]),
            this.createAuthorizationDocumentsHeader(),
        );
    }

    async uploadFile(data: {
        customerId: number;
        date: string;
        formData: any;
    }): Promise<{ filename: string }> {
        return (
            await this.post(
                `health-reports/${data.customerId}/${data.date}`,
                data.formData,
                this.createAuthorizationHeader(),
            )
        ).data;
    }
}
const healthReportsRepository = new HealthReports();
export default healthReportsRepository;
